export default __webpack_public_path__ + "static/minebest-a6c4dc896e55feda9bd8f8302f3b3a08.webm";